import { render, staticRenderFns } from "./book.vue?vue&type=template&id=6cd19d2f&scoped=true"
import script from "./book.vue?vue&type=script&lang=js"
export * from "./book.vue?vue&type=script&lang=js"
import style0 from "./book.vue?vue&type=style&index=0&id=6cd19d2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd19d2f",
  null
  
)

export default component.exports